module.exports = __webpack_public_path__ + "img/plexus-3.4fdb987a.png";